import { render, staticRenderFns } from "./ConfirmPreScoring.vue?vue&type=template&id=8216caa8&"
import script from "./ConfirmPreScoring.vue?vue&type=script&lang=js&"
export * from "./ConfirmPreScoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports